export default "__VITE_ASSET__BoSF8i4o__"